export enum ItemType {
  FullWidthItem,
  PromoteItem,
  ListItem,
}
export interface HeaderItemsWithHeight {
  [key: string]: number;
}

export enum HeaderItems {
  HomeBanner = 'home-banner',
  ShortcutButtons = 'shortcut-buttons',
  CategoryList = 'category-list',
  OnboardingTitle = 'onboarding-title',
  OnboardingList = 'onboarding-list',
  OnSale = 'on-sale',
  PromoteItems = 'promote-items',
  SectionPromote = 'section-promote',
  TopSalesTitle = 'top-sales-title',
  TopSales = 'top-sales',
  TopRatedTitle = 'top-rated-title',
  TopRated = 'top-rated',
  SpecialForYouTitle = 'special-for-you',
  SpecialForYouList = 'special-for-you-list',
}

export const HEADER_KEYS = Object.values(HeaderItems).filter(item => {
  switch (item) {
    case HeaderItems.OnboardingTitle:
    case HeaderItems.OnboardingList:
    case HeaderItems.PromoteItems:
    case HeaderItems.OnSale:
      return false;
    case HeaderItems.TopRated:
    case HeaderItems.TopRatedTitle:
    default:
      return true;
  }
}) as string[];
